/**
 * Determine if a color is a light color
 * @see https://gist.github.com/krabs-github/ec56e4f1c12cddf86ae9d551aa9d9e04
 */
export function isLightColor(color: string): boolean {
  const hexColor = +`0x${color.slice(1).replace(color.length < 5 ? /./g : "", "$&$&")}`;
  const r = hexColor >> 16;
  const g = (hexColor >> 8) & 255;
  const b = hexColor & 255;

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  // > 127.5 is 'light', <= 127.5 is 'dark'
  return hsp > 170;
}

/**
 * The colours a label may be given, grouped as the swatch grid renders them: one
 * hue per row, light to dark across it. The create and edit label modals and the core
 * label picker all draw from this list, so a colour a label is created with is a
 * colour it can be edited back to.
 */
export const LABEL_COLOR_SWATCHES = [
  // Red shades
  ["#ffa2a2", "#ff6467", "#fb2c36", "#e7000b", "#c10007"],
  // Yellow/Orange shades
  ["#ffdf20", "#fdc700", "#f0b100", "#d08700", "#a65f00"],
  // Green shades
  ["#bbf451", "#9ae600", "#7ccf00", "#5ea500", "#497d00"],
  // Blue shades
  ["#8ec5ff", "#51a2ff", "#2b7fff", "#155dfc", "#1447e6"],
  // Purple shades
  ["#c4b4ff", "#a684ff", "#8e51ff", "#7f22fe", "#7008e7"],
  // Pink shades
  ["#fda5d5", "#fb64b6", "#f6339a", "#e60076", "#c6005c"],
  // Additional red variations
  ["#ffcccc", "#ff9999", "#ff6666", "#ff3333", "#cc0000"],
  // Additional orange variations
  ["#ffcc99", "#ff9966", "#ff6633", "#ff3300", "#cc3300"],
  // Additional green variations
  ["#ccffcc", "#99ff99", "#66ff66", "#33ff33", "#00cc00"],
  // Additional blue variations
  ["#cce5ff", "#99ccff", "#66b3ff", "#3399ff", "#0066cc"],
  // Additional purple variations
  ["#e6ccff", "#cc99ff", "#b366ff", "#9933ff", "#6600cc"],
  // Additional pink variations
  ["#ffcce6", "#ff99cc", "#ff66b3", "#ff3399", "#cc0066"],
] as const;

/** The swatch a label starts on when nobody picks one: the mid red of the first row. */
export const DEFAULT_LABEL_COLOR: string = LABEL_COLOR_SWATCHES[0][2];
